"use strict";
exports.__esModule = true;
exports["default"] = {
    steps: {
        phone: {
            title: '帳號登入',
            text: '請輸入您的手機，確認是否為香緹卡會員',
        },
        phoneCode: {
            title: '電話認證'
        },
        emailCode: {
            title: 'email認證'
        },
        signIn: {
            title: '確認成功！',
            text: '您的電話號碼已完成認證',
        }
    }
};
